import React from 'react';
// import Footer from './Footer';
import { useNavigate } from "react-router-dom";
const AutonomousNavigationPage = () => {
   const navigate = useNavigate();
  return (
    <>
      <style>{`
        .page-hero-title {
          opacity: 0;
          transform: translateY(28px) scale(0.98);
          animation: pageHeroTitleReveal 1s ease-out forwards;
        }

        @keyframes pageHeroTitleReveal {
          0% {
            opacity: 0;
            transform: translateY(28px) scale(0.98);
            letter-spacing: 0.02em;
            filter: blur(8px);
          }
          60% {
            opacity: 1;
            transform: translateY(-4px) scale(1.01);
            filter: blur(0);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
            letter-spacing: 0;
            filter: blur(0);
          }
        }
      `}</style>
      <div style={{ backgroundColor: '#fff', color: '#000' }}>
        <section className="section" style={{ maxWidth: 1200, margin: '0 auto', padding: '120px 20px' }}>
          {/* Back Button */}
           <div style={{ marginBottom: 30 }}>
           <p
           style={{
            display: "inline-block",
           cursor: "pointer",
           margin: 0,
           fontSize: 14,
           color: "#555555"
           }}
         onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
         onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
         onClick={() => navigate("/", { state: { openMenu: true } })}
  >
          ← Back to Menu
         </p>
         </div>

         
           <h1 className="page-hero-title" style={{ marginBottom: 24, textAlign: 'left' }}>AI-Powered Satellite Solutions</h1>
           <p style={{ opacity: 0.85, lineHeight: 1.7, maxWidth: 900 }}>
            Satellites are becoming intelligent, autonomous systems. Our services enable smarter onboard
            processing, predictive analytics, and autonomous decision-making both in orbit and on the ground.
          </p>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Our AI-Enhanced Satellite Services</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginTop: 12 }}>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Autonomous Satellite Operations</h3>
                <p>Real-time orbit adjustments, collision avoidance, and optimized capture.</p>
                <p style={{ opacity: 0.8 }}>Example: ESA OPS-SAT tests onboard AI for autonomy.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Intelligent Earth Observation</h3>
                <p>Detect patterns and changes across land, sea, and atmosphere at scale.</p>
                <p style={{ opacity: 0.8 }}>Example: Planet Labs monitors deforestation and urban growth.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Predictive Maintenance & Health Monitoring</h3>
                <p>Analyze telemetry to predict component failures and extend lifespan.</p>
                <p style={{ opacity: 0.8 }}>Example: NASA predicts spacecraft degradation pre-failure.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Space Traffic Management</h3>
                <p>Track objects in orbit, predict collisions, optimize positioning.</p>
                <p style={{ opacity: 0.8 }}>Example: LeoLabs provides LEO collision alerts.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Enhanced Communications & Signal Processing</h3>
                <p>Improve bandwidth, clarity, and routing with AI-driven optimization.</p>
                <p style={{ opacity: 0.8 }}>Example: AI-managed beamforming in satellite internet.</p>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Why Choose Our AI Satellite Services</h2>
            <ul style={{ listStyle: 'disc', paddingLeft: 20, lineHeight: 1.8 }}>
              <li>Real-time intelligence for autonomous operations</li>
              <li>Advanced analytics for Earth observation</li>
              <li>Mission resilience through predictive monitoring</li>
              <li>Scalable for LEO, MEO, and GEO missions</li>
              <li>Compliance and safety via AI-driven traffic control</li>
            </ul>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default AutonomousNavigationPage;


